import React, { useEffect, useState } from "react";
import CommonSearchableDropdownInput from "../../common/inputs/CommonSearchableDropdownInput";
import useInvoiceApi from "../../../hooks/useInvoiceApi";

function CreateInvoiceCustomerSection({
  data,
  setData,
  setModal,
  customers,
  setCustomers,
}) {
  const { getCustomers } = useInvoiceApi();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const loadData = async () => {
    await getCustomers({
      noSave: true,
      search,
      setLoading,
      callback: (items) => {
        const mutatedItems = items?.map((item) => {
          let nameArray = [item?.firstName];
          if (item?.middleName) {
            nameArray = [...nameArray, item?.middleName];
          }
          nameArray = [...nameArray, item?.lastName];
          return {
            label: nameArray?.join(" "),
            value: item?._id,
            data: item,
          };
        });
        setCustomers(mutatedItems);
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [search]);

  return (
    <div className="w-full flex flex-col">
      <CommonSearchableDropdownInput
        label="Choose customer"
        placeholder="Search for customer"
        value={data?.customer}
        options={customers}
        optionObject
        searchDefault={
          customers?.find((customer) => customer?._id === data?.customer)
            ?.firstName || ""
        }
        onSearchChange={(searchData) => {
          setSearch(searchData);
        }}
        loading={loading}
        onChange={(val) => {
          setData({
            ...data,
            customer: val,
          });
        }}
      />
      <button
        className="text-primary1 font-bold text-sm my-1 text-left"
        onClick={() => {
          setModal(true);
        }}
      >
        + New customer
      </button>
    </div>
  );
}

export default CreateInvoiceCustomerSection;
